import React from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from 'react-metrics';

import Link from '../../shared/components/hyperlink';
import PurchaseButtonContainer from './purchase-button-container';
import Button from '../../ui/components/button';

const defaultCTAText = {
    CTO: 'Customize & Buy',
};

const ProductCTA = ({
    product = {},
    to,
    ctaText,
    history,
    jumpid,
    enableAddToQuote,
    enableCTOAddToCart,
    isV2,
    productClickMetrics,
    ctaMetrics,
    baseProductSku,
    xsellType,
    templateKey,
    popupConfig,
    ...otherProps
}) => {
    let isParentPrd = product.prdClass === 'PRT';
    //if destination prop passed or is parent product, link to destination
    let linkUrl;
    if (!!to) {
        linkUrl = to;
    } else if (isParentPrd) {
        linkUrl = product.slug ? `/pdp/${product.slug}` : `/pdp/${(product.linkUrl || '').split('/').pop()}`;
    }
    ctaText = ctaText || (product && defaultCTAText[product.prdClass]) || 'Shop Now';
    if (linkUrl) {
        let hasProductClickMetrics =
            typeof productClickMetrics === 'object' && productClickMetrics && templateKey === 'pdp';
        let linkComponent = (
            <MetricsElement>
                <Link
                    to={linkUrl}
                    className={isV2 ? 'new-btn' : 'btn btn-primary'}
                    {...(hasProductClickMetrics ? productClickMetrics : {})}
                >
                    {ctaText}
                </Link>
            </MetricsElement>
        );
        return isV2 ? (
            <div className={'purchase-btn-container'}>
                <Button linkComponent={linkComponent} type={'tertiary'} variation={'left'} className={'purchase'} />
            </div>
        ) : (
            <div className="product-cta" style={{ display: 'inline-block' }}>
                {linkComponent}
            </div>
        );
    } else {
        return (
            <PurchaseButtonContainer
                product={product}
                enableAddToQuote={enableAddToQuote}
                enableCTOAddToCart={enableCTOAddToCart}
                isV2={isV2}
                jumpid={jumpid}
                metrics={ctaMetrics}
                baseProductSku={baseProductSku}
                xsellType={xsellType}
                templateKey={templateKey}
                popupConfig={popupConfig}
                {...otherProps}
            />
        );
    }
};

export default ProductCTA;
